import templateDefaults from '../templateDefaults';

export default {
  previewImage: '/img/modern/title-bar.png',
  title: 'Title Bar',
  templateData() {
    return {
      version: 'v1.1',
      title: 'Modern Title Bar',
      ...templateDefaults,
      elements: [
        {
          version: 'v1',
          type: 'text',
          editable: true,
          name: 'Title',
          locked: false,
          text: '<p>TITLE AND ORGANIZATION</p>',
          cssClasses: '',
          animation: true,
          loopAnimation: false,
          animationInStyle: 'slideInDown',
          animationInDuration: 750,
          animationInDelay: 750,
          animationInEasing: '0.250, 0.100, 0.250, 1.000',
          animationOutStyle: 'fadeOut',
          animationOutDuration: 750,
          animationOutDelay: 0,
          animationOutEasing: '0.250, 0.100, 0.250, 1.000',
          textShadow: false,
          textShadowX: 1,
          textShadowY: 2,
          textShadowBlur: 4,
          textShadowColor: '#000000',
          ticker: false,
          fillStyle: 'solid',
          backgroundColor: '#00c4dd',
          backgroundSize: 'cover',
          gradientDirection: 180,
          gradientColorOne: '#00c4dd',
          gradientColorTwo: '#0f84fb',
          background: false,
          styles: {
            top: 970,
            left: 129,
            width: 600,
            height: 40,
            opacity: 1,
            color: '#000000',
            fontFamily: 'Roboto',
            textTransform: 'none',
            textDecoration: 'none',
            fontSize: 36,
            fontWeight: 'normal',
            fontStyle: 'normal',
            letterSpacing: 0,
          },
        },
        {
          version: 'v1',
          type: 'text',
          editable: true,
          name: 'First Last Name',
          locked: false,
          text: '<p><strong>FIRST LAST NAME</strong></p>',
          cssClasses: '',
          animation: true,
          loopAnimation: false,
          animationInStyle: 'slideInUp',
          animationInDuration: 750,
          animationInDelay: 750,
          animationInEasing: '0.250, 0.100, 0.250, 1.000',
          animationOutStyle: 'fadeOut',
          animationOutDuration: 750,
          animationOutDelay: 0,
          animationOutEasing: '0.250, 0.100, 0.250, 1.000',
          textShadow: false,
          textShadowX: 1,
          textShadowY: 2,
          textShadowBlur: 4,
          textShadowColor: '#000000',
          ticker: false,
          fillStyle: 'solid',
          backgroundColor: '#00c4dd',
          backgroundSize: 'cover',
          gradientDirection: 180,
          gradientColorOne: '#00c4dd',
          gradientColorTwo: '#0f84fb',
          background: false,
          styles: {
            top: 886,
            left: 129,
            width: 813,
            height: 80,
            opacity: 1,
            color: '#000000',
            fontFamily: 'Roboto',
            textTransform: 'uppercase',
            textDecoration: 'none',
            fontSize: 72,
            fontWeight: 'normal',
            fontStyle: 'normal',
            letterSpacing: 0,
          },
        },
        {
          version: 'v1',
          type: 'rectangle',
          name: 'Rectangle',
          locked: false,
          aspectLock: false,
          cssClasses: '',
          animation: true,
          loopAnimation: false,
          animationInStyle: 'slideInLeft',
          animationInDuration: 750,
          animationInDelay: 0,
          animationInEasing: '0.250, 0.100, 0.250, 1.000',
          animationOutStyle: 'slideOutLeft',
          animationOutDuration: 750,
          animationOutDelay: 750,
          animationOutEasing: '0.250, 0.100, 0.250, 1.000',
          border: false,
          borderWidth: 2,
          borderColor: '#000000',
          boxShadow: false,
          boxShadowX: 1,
          boxShadowY: 2,
          boxShadowBlur: 4,
          boxShadowSpread: 0,
          boxShadowColor: '#000000',
          fillStyle: 'gradient',
          backgroundColor: '#00c4dd',
          backgroundSize: 'cover',
          gradientDirection: 90,
          gradientColorOne: 'rgb(4, 82, 183)',
          gradientColorTwo: 'rgb(0, 33, 76)',
          backgroundImage: false,
          backgroundImageUrl: '',
          borderTopLeftRadius: 0,
          borderTopRightRadius: 0,
          borderBottomRightRadius: 0,
          borderBottomLeftRadius: 0,
          blur: false,
          blurSize: 10,
          styles: {
            top: 853,
            left: 98,
            width: 1074,
            height: 18,
            opacity: 1,
          },
        },
        {
          version: 'v1',
          type: 'rectangle',
          name: 'Rectangle',
          locked: false,
          aspectLock: false,
          cssClasses: '',
          animation: true,
          loopAnimation: false,
          animationInStyle: 'slideInLeft',
          animationInDuration: 750,
          animationInDelay: 0,
          animationInEasing: '0.250, 0.100, 0.250, 1.000',
          animationOutStyle: 'slideOutLeft',
          animationOutDuration: 750,
          animationOutDelay: 750,
          animationOutEasing: '0.250, 0.100, 0.250, 1.000',
          border: false,
          borderWidth: 2,
          borderColor: '#000000',
          boxShadow: false,
          boxShadowX: 1,
          boxShadowY: 2,
          boxShadowBlur: 4,
          boxShadowSpread: 0,
          boxShadowColor: '#000000',
          fillStyle: 'gradient',
          backgroundColor: 'rgb(255, 255, 255)',
          backgroundSize: 'cover',
          gradientDirection: 0,
          gradientColorOne: 'rgb(221, 221, 221)',
          gradientColorTwo: 'rgb(255, 255, 255)',
          backgroundImage: false,
          backgroundImageUrl: '',
          borderTopLeftRadius: 0,
          borderTopRightRadius: 0,
          borderBottomRightRadius: 0,
          borderBottomLeftRadius: 0,
          blur: false,
          blurSize: 10,
          styles: {
            top: 871,
            left: 98,
            width: 1074,
            height: 153,
            opacity: 1,
          },
        },
      ],
    };
  },
};
